const CONTROLLER = "/members";
const PATHS = {
  GET_PREVIEW_BATCH: "/preview",
  GET_USER: "/:user_id",
  GET_ALL_USERS: "",
  UPDATE_USER: "/:user_id",
  COMPLETE_PROFILE: "/:user_id",
  GET_USER_POSTS: "/:user_id/posts",
  GET_USER_JOBS: "/:user_id/jobs",
};

export const MembersApiRoutesNames = Object.fromEntries(
  (Object.keys(PATHS) as Array<keyof typeof PATHS>).map((k) => [k, k])
) as {
  [K in keyof typeof PATHS]: K;
};

export const MembersApiRoutes = {
  CONTROLLER,
  PATHS,
  GET_PREVIEW_BATCH: `${CONTROLLER}${PATHS.GET_PREVIEW_BATCH}`,
  GET_USER: (user_id: string | undefined) =>
    `${CONTROLLER}${PATHS.GET_USER.replace(":user_id", String(user_id))}`,
  GET_ALL_USERS: `${CONTROLLER}${PATHS.GET_ALL_USERS}`,
  UPDATE_USER: (user_id: string | undefined) =>
    `${CONTROLLER}${PATHS.UPDATE_USER.replace(":user_id", String(user_id))}`,
  COMPLETE_PROFILE: (user_id: string | undefined) =>
    `${CONTROLLER}${PATHS.COMPLETE_PROFILE.replace(
      ":user_id",
      String(user_id)
    )}`,
  GET_USER_POSTS: (user_id: string | undefined) =>
    `${CONTROLLER}${PATHS.GET_USER_POSTS.replace(":user_id", String(user_id))}`,
  GET_USER_JOBS: (user_id: string | undefined) =>
    `${CONTROLLER}${PATHS.GET_USER_JOBS.replace(":user_id", String(user_id))}`,
};
